import React, {memo} from 'react';
import {t} from '../../services/i18nHandler';
import VideoMaterialSwiper from './VideoMaterialsSwiper/VideoMaterialSwiper';

function LandingPageVideomaterialsSection({videoMaterials}) {
  return (
    <div className="section section--videomaterials" data-anchor="video-materials">
      <div className="section--inner">
        <div className="section--container">
          <div className="videomaterials_wrap">
            <div className="section--slogan">{t('landingPage.videoMaterials.intro')}</div>
            <div className="section--title">{t('landingPage.videoMaterials.title')}</div>
            <VideoMaterialSwiper videoMaterials={videoMaterials} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(LandingPageVideomaterialsSection);
